import { Box } from "@mui/material";
import { styled } from "@mui/styles";

export const Row = styled(Box)({
    display: "flex",
    width: "100%",
    gap: "1rem",
    flexDirection: "row",
})